import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

export function AppShell(): JSX.Element {
  const location = useLocation();
  return (
    <div className="flex h-screen w-full overflow-hidden bg-background">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar />
        <main className="relative flex-1 overflow-y-auto">
          <div
            aria-hidden
            className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-gradient-to-b from-primary/[0.04] to-transparent"
          />
          <div
            key={location.pathname}
            className="relative mx-auto w-full max-w-7xl animate-fade-in-up px-6 py-8 lg:px-8"
          >
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
